export default __webpack_public_path__ + "static/media/Frame.21334f39.svg";